export default {
  formTitle: 'Contact us',
  submit: 'Send',
  mail: 'E-Mail',
  name: 'Name',
  comment: 'Nachricht',
  sendText: 'Vielen danke fur kontaktiert uns!',
  toForm: 'Back'
}


// WEBPACK FOOTER //
// ./src/locale/de-DE/contactUs.js